import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import CovidComponent from '../../../components/Mouvement/Panel/CovidComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class CovidPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.COVID;
		this.icon = { name: 'syringe' };
	}

	getLibelle = () => 'Covid 19';

	isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.covid19);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<CovidComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default CovidPanel;
